import React from "react";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import {GreyButton} from "../common/ButtonsConstants";
import Paper from "@material-ui/core/Paper";
import {KeyboardDatePicker} from "@material-ui/pickers";
import SignaturePad from "react-signature-canvas";
import moment from "moment";
import {withStyles} from "@material-ui/styles";
import PropTypes from "prop-types";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    fullWidth : {
        width: '100%',
        borderRadius: 0
    },
}));

class SwmsPartTwo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            principalContractorName: props.state.principalContractorName,
            principalContractorCompanyName: props.state.principalContractorCompanyName,
            dateSwmsProvidedByContractor: props.state.dateSwmsProvidedByContractor,
            contractorSignature: props.state.contractorSignature,
            contractorSignatureDate: props.state.contractorSignatureDate,
            responsiblePersonName: props.state.responsiblePersonName,
            responsiblePersonSignature: props.state.responsiblePersonSignature,
            responsiblePersonDate: props.state.responsiblePersonDate,
        };
        this.onChange = this.onChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onSignatureDrawn = this.onSignatureDrawn.bind(this);
    }

    onChange(event) {
        this.props.onChangeHandler();
        this.setState({
            ...this.state, [event.target.name]: event.target.value
        });
    }

    onDateChange(date, fieldName) {
        this.props.onChangeHandler();
        this.setState({
            ...this.state, [fieldName]: moment(date, "DD/MM/YYYY"),
        });
    }

    onSignatureDrawn(fileName, sigPad) {
        this.props.onChangeHandler();
        this.props.onSignatureDrawn(fileName, sigPad);
    }

    render() {
        let {state} = this;

        return <Grid container spacing={0} style={{  }}>
            <Grid item xs={6}>
                <Paper square>
                    <TextField
                        id="principalContractorName"
                        name="principalContractorName"
                        value={state.principalContractorName}
                        label="Name of Principal Contractor"
                        onChange={this.onChange}
                        variant="outlined"
                        style={{ width: '100%' }}
                    />
                </Paper>
            </Grid>
            <Grid item xs={6}>
                <Paper square>
                    <TextField
                        id="principalContractorCompanyName"
                        name="principalContractorCompanyName"
                        value={state.principalContractorCompanyName}
                        label="Principal Contractor Company Name"
                        onChange={this.onChange}
                        variant="outlined"
                        style={{ width: '100%' }}
                    />
                </Paper>
            </Grid>
            <Grid item xs={6}>
                <Paper square>
                    <KeyboardDatePicker
                        disableToolbar
                        autoOk
                        variant="outlined"
                        format="DD/MM/YYYY"
                        id="dateSwmsProvidedByContractor"
                        label="Date SWMS provided to Principal Contractor"
                        name="dateSwmsProvidedByContractor"
                        value={state.dateSwmsProvidedByContractor}
                        onChange={(event) => this.onDateChange(event, 'dateSwmsProvidedByContractor')}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        style={{ width: "100%", marginTop: "8px", paddingLeft: "8px"}}
                    />
                </Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper square>
                    <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                        Principal Contractor Signature:
                        <SignaturePad
                            canvasProps={{ width: "250px", height: "150px" }}
                            onEnd={() => this.onSignatureDrawn('contractorSignature', this.principalContratorSigPad)}
                            ref={(ref) => {
                                this.principalContratorSigPad = ref;
                                if (state.contractorSignature && this.principalContratorSigPad) {
                                    this.principalContratorSigPad.fromDataURL(state.contractorSignature, { width: 250, height: 150})
                                }
                            }}
                        />
                        <GreyButton onClick={() => this.principalContratorSigPad.clear()}>
                            CLEAR
                        </GreyButton>
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper square>
                    <KeyboardDatePicker
                        disableToolbar
                        autoOk
                        variant="outlined"
                        format="DD/MM/YYYY"
                        id="contractorSignatureDate"
                        label="Date"
                        name="contractorSignatureDate"
                        value={state.contractorSignatureDate}
                        onChange={(event) => this.onDateChange(event, 'contractorSignatureDate')}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        style={{ width: "100%", marginTop: "8px", paddingLeft: "8px"}}
                    />
                </Paper>
            </Grid>
            <Grid item xs={6}>
                <Paper square>
                    <TextField
                        id="responsiblePersonName"
                        name="responsiblePersonName"
                        value={state.responsiblePersonName}
                        label="Name of person responsible for ensuring compliance with SWMS"
                        onChange={this.onChange}
                        variant="outlined"
                        style={{ width: '100%' }}
                    />
                </Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper square>
                    <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                        Signature (please use mouse or touchpad to sign):
                        <SignaturePad
                            canvasProps={{ width: "250px", height: "150px" }}
                            onEnd={() => this.onSignatureDrawn('responsiblePersonSignature', this.responsibleSigPad)}
                            ref={(ref) => {
                                this.responsibleSigPad = ref;
                                if (state.responsiblePersonSignature && this.responsibleSigPad) {
                                    this.responsibleSigPad.fromDataURL(state.responsiblePersonSignature, { width: 250, height: 150})
                                }
                            }}
                        />
                        <GreyButton onClick={() => this.responsibleSigPad.clear()}>
                            CLEAR
                        </GreyButton>
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper square>
                    <KeyboardDatePicker
                        disableToolbar
                        autoOk
                        variant="outlined"
                        format="DD/MM/YYYY"
                        id="responsiblePersonDate"
                        label="Date"
                        name="responsiblePersonDate"
                        value={state.responsiblePersonDate}
                        onChange={(event) => this.onDateChange(event, 'responsiblePersonDate')}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        style={{ width: "100%", marginTop: "8px", paddingLeft: "8px"}}
                    />
                </Paper>
            </Grid>
        </Grid>;
    }
}

SwmsPartTwo.propTypes = {
    onChangeHandler: PropTypes.func.isRequired,
};

export default withStyles(classes)(SwmsPartTwo);